/** Not extracted in term-sheet / initial-materials modes — never apply from those payloads. */
export const EXTRACTION_LEAD_SUPPORT_KEYS = [
  "deal_lead",
  "deal_support",
] as const;

/** Deal fields that must not be overwritten when merging initial materials extraction. */
export const INITIAL_MATERIALS_PROTECTED_DEAL_KEYS = [
  "deal_name",
  "sponsor",
  "tf_servicing_fee",
  "tf_arrangement_fee",
  "source",
  "countries",
  "sectors",
  "loan_type",
  "security_type",
  "transaction_type",
  "risk_class",
  "executive_summary",
  "deal_name_alias",
  "probability",
  "priority",
  "deal_summary",
  "market_summary",
  "risks",
  "strategy",
  "deal_purpose",
  ...EXTRACTION_LEAD_SUPPORT_KEYS,
] as const;

/** Deal fields preserved when merging term sheet extraction on an existing deal. */
export const TERM_SHEET_PROTECTED_DEAL_KEYS = [
  "deal_name",
  "sponsor",
  ...EXTRACTION_LEAD_SUPPORT_KEYS,
] as const;

export function filterDealDataForExtractionMerge(
  dealData: Record<string, unknown>,
  options: { isTermSheet?: boolean; isInitialMaterials?: boolean },
): Record<string, unknown> {
  const protectedKeys = new Set<string>();

  if (options.isInitialMaterials) {
    INITIAL_MATERIALS_PROTECTED_DEAL_KEYS.forEach((key) => protectedKeys.add(key));
  } else if (options.isTermSheet) {
    TERM_SHEET_PROTECTED_DEAL_KEYS.forEach((key) => protectedKeys.add(key));
  }

  if (protectedKeys.size === 0) {
    const { nda: _nda, nda_id: _ndaId, ...rest } = dealData;
    return rest;
  }

  return Object.fromEntries(
    Object.entries(dealData).filter(
      ([key]) => !protectedKeys.has(key) && key !== "nda" && key !== "nda_id",
    ),
  );
}
